import React from 'react';
import Helmet from "react-helmet";
import {Card, CardGroup, Row, Col} from 'react-bootstrap';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';

import speaker from "../../assets/images/contents/ProfDrAgusHarjoko.jpg"

export const ProfDrAgusHarjoko = () => (
  <div>
    <Helmet>
      <title>The 7th International Conference on Soft Computing in Data Science 2022 (scds2023) - Keynote Speaker</title>
    </Helmet>
    <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Prof Dr Agus Harjoko</li>
      </ol>
    </nav>
    {/* <h2>Abstract - Professor Dr. Richard C Millham</h2> <br/>   */}

    <Container> 
      <Row className="justify-content-md-center">  
        <Col md="auto">
          <Card>
            <Card.Img width="100px" height="220px" src={speaker} alt="speaker image" /> 
          </Card>             
        </Col>
      </Row>
    </Container>

    <p style={{textAlign:'center'}}>
      <b>Professor Dr Agus Harjoko</b>
    </p>

    <p style={{textAlign:'center'}}>
      Department of Computer Science and Electronics (DCSE), Universitas Gadjah Mada
    </p>

    <br/>

    <h4 style={{textAlign:'center'}}>Multimodal Analytics in Security Authentication</h4>

    <p style={{ textAlign:'justify'}}><b>Abstract</b><br/>
      Strong authentication is increasingly being improved. The methods used to ensure the integrity of user authentication of a device are also growing. In order to increase the 
      level of security, the biometrics model is considered suitable to replace the conventional security model. Besides being able to support the high mobility of modern society, 
      biometrics are also able to ensure that the only person who can open the lock is the owner of the device. The speech will share the methodology and results for the development
      of a multimodal biometric model that combines hand geometry and voice features. A proposed multimodal biometric model is established. It has been successfully developed and 
      proven to be more reliable than its unimodal model.
    </p>

    <p style={{ textAlign:'justify'}}><b>Biography</b><br/>
      Agus Harjoko received the bachelor’s degree in electronics and instrumentation from Universitas Gadjah Mada (UGM), Yogyakarta, Indonesia, in 1986, and the M.Sc. and 
      Ph.D. degrees in computer science from the University of New Brunswick, Fredericton, NB, Canada, in 1990 and 1996, respectively. He is currently a Professor 
      and the Head of the Department of Computer Science and Instrumentation, UGM. His research interests include computer vision and pattern recognition.
    </p>

    <p style={{ textAlign:'justify'}}>Click this <b><a href = "https://acadstaff.ugm.ac.id/aharjoko" target="_blank">link</a></b> to see his further detail bio.<br/></p>

  </div>
)